<template>
    <div class="link-document-item-img">
        <img :src="image" @click="preview">
    </div>
</template>

<script>
    export default {
        name: "link-document-item-img",
        props: ['data'],
        data() {
            // console.log(this.data)
            let image = this.data.setting.img
            // console.log(!/^(http|https)/.test(image), image)
            if (!/^(http|https)/.test(image)) {
                image = window.CONFIG.publicPath + image
            }
            // console.log(image)
            return {
                image,
            }
        },
        methods: {
            preview() {
                !!this.image && this.$slider.pick({
                    picData: [this.image],
                    picKey: null,
                })
            },
        }
    }
</script>

<style lang="scss">
    .link-document-item-img {
        img {
            max-height: 300px;
            height: auto;
            cursor: pointer;
        }
    }
</style>
